import { derived } from 'svelte/store';
import type { WmsAccessSummary } from '$lib/api/modules-access';
import { loadModulesAccess, modulesAccess, modulesAccessState, resetModulesAccess } from './modulesAccess';

export type { WmsAccessSummary } from '$lib/api/modules-access';

export const wmsAccess = derived(modulesAccess, ($modulesAccess) => $modulesAccess.wms);
export const canManagePickingPriority = derived(wmsAccess, ($access) =>
  $access.canAccessModule && $access.effectivePermissions.includes('wms.picking.priority.manage'));
export const wmsAccessState = modulesAccessState;
export const isLoadingWmsAccess = derived(modulesAccessState, ($state) => $state.status === 'refreshing');

export async function loadWmsAccess(force = false): Promise<void> {
  await loadModulesAccess(force);
}

export function resetWmsAccess(): void {
  resetModulesAccess();
}
